import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { TextFieldModule } from '@angular/cdk/text-field';
import { DOCUMENT, NgClass } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostBinding, HostListener, Inject, NgZone, OnDestroy, OnInit, Renderer2, ViewChild, SimpleChanges, ChangeDetectorRef, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CartService } from 'app/core/cart/cart.service';
import { Cart } from 'app/core/cart/cart.types';
import { TruncatePipe } from '@app-core/pipes/truncate.pipe';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-sidebar',
	standalone: true,
	imports: [NgClass, MatIconModule, MatButtonModule, MatFormFieldModule, MatInputModule, TextFieldModule, TruncatePipe, CommonModule],
	exportAs: 'sideBar',
	templateUrl: './sidebar.component.html',
	styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild('messageInput') messageInput: ElementRef;
	chat: any;

	cartData: any;
	saleId: any;
	chats: any[];
	opened: boolean = false;
	selectedChat: any;
	dataSource: any;
	totalPrice: number = 0;
	subtotalPrice: number = 0;
	taxPrice: number = 0;
	addCodeBool: boolean = false;
	cart: Cart;
	canEditCart: boolean = true;
	lines: boolean = false;
	uuid: string = '';
	private _mutationObserver: MutationObserver;
	private _scrollStrategy: ScrollStrategy = this._scrollStrategyOptions.block();
	private _overlay: HTMLElement;
	private _unsubscribeAll: Subject<any> = new Subject<any>();
	private _snackBar = inject(MatSnackBar);

	/**
	 * Constructor
	 */
	constructor(
		@Inject(DOCUMENT) private _document: Document,
		private _elementRef: ElementRef,
		private _renderer2: Renderer2,
		private _ngZone: NgZone,
		private _router: Router,
		private cartService: CartService,
		private _scrollStrategyOptions: ScrollStrategyOptions,
		private _changeDetectorRef: ChangeDetectorRef,
		private router: Router,
	) {
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Decorated methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Host binding for component classes
	 */
	@HostBinding('class') get classList(): any {
		return {
			'app-sidebar-opened': this.opened,
		};
	}

	/**
	 * Resize on 'input' and 'ngModelChange' events
	 *
	 * @private
	 */
	@HostListener('input')
	@HostListener('ngModelChange')
	private _resizeMessageInput(): void {
		// This doesn't need to trigger Angular's change detection by itself
		this._ngZone.runOutsideAngular(() => {
			setTimeout(() => {
				// Set the height to 'auto' so we can correctly read the scrollHeight
				this.messageInput.nativeElement.style.height = 'auto';

				// Get the scrollHeight and subtract the vertical padding
				this.messageInput.nativeElement.style.height = `${this.messageInput.nativeElement.scrollHeight}px`;
			});
		});
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.getCart();
	}

	getCart(){
		this.cartService.getCart()
			.subscribe({
				next: (res) => {
					if (res?.status == true) {
						this.cartData = res?.data?.cart;
						this.getAllElements()
					}
				}
			})
	}

	getAllElements(): void {
		this.canEditCart = true;
		this.saleId = this.cartData?.id
		this.dataSource = this.cartData?.order_line;
		this.dataSource = this.dataSource.map(product => ({
			...product,
			quantity: product.quantity
		}));
		this.totalPrice = this.cartData?.amount_total;
		this.subtotalPrice = this.cartData?.amount_untaxed;
		this.taxPrice = this.cartData?.amount_tax;
		this.uuid = this.cartData?.uuid;
		if (this.cartData?.order_line.length > 0){
			this.lines = true;
		} else {
			this.lines = false;
		}
		this._changeDetectorRef.detectChanges();
	}
	/**
	 * After view init
	 */
	ngAfterViewInit(): void {
		// Fix for Firefox.
		//
		// Because 'position: sticky' doesn't work correctly inside a 'position: fixed' parent,
		// adding the '.cdk-global-scrollblock' to the html element breaks the navigation's position.
		// This fixes the problem by reading the 'top' value from the html element and adding it as a
		// 'marginTop' to the navigation itself.
		this._mutationObserver = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				const mutationTarget = mutation.target as HTMLElement;
				if (mutation.attributeName === 'class') {
					if (mutationTarget.classList.contains('cdk-global-scrollblock')) {
						const top = parseInt(mutationTarget.style.top, 10);
						this._renderer2.setStyle(this._elementRef.nativeElement, 'margin-top', `${Math.abs(top)}px`);
					}
					else {
						this._renderer2.setStyle(this._elementRef.nativeElement, 'margin-top', null);
					}
				}
			});
		});
		this._mutationObserver.observe(this._document.documentElement, {
			attributes: true,
			attributeFilter: ['class'],
		});
	}
	trackByFn(index: number, item: any): any {
		return item.id || index;
	}
	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Disconnect the mutation observer
		this._mutationObserver.disconnect();

		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	addCode(): void {
		this.addCodeBool = true;
	}

	deleteProduct(id: number): void {
		this.canEditCart = false;
		this.cartService.deleteLineCart(Number(this.saleId),Number(id))
			.subscribe({
				next: (res) => {
					if (res?.status == true) {
						this.cartData = res?.data?.cart;
						this.openSnackBar("Se elimino el producto correctamente.", true);
						this.getAllElements()
					}
				}
			})
	}

	deleteAllproducts(): void {
		this.canEditCart = false;
		this.cartService.clearCart(Number(this.saleId))
			.subscribe({
				next: (res) => {
					if (res?.status == true) {
						this.cartData = res?.data?.cart;
						this.openSnackBar("Carrito vacio", true);
						this.getAllElements()
					}
				}
			})
	}
	/**
	 * Open the panel
	 */
	open(): void {
		// Return if the panel has already opened
		if (this.opened) {
			return;
		}

		// Open the panel
		this.getCart();
		this._toggleOpened(true);
	}

	increment(product: any): void {
		if (product.quantity < product.maximum_quantity) {
			this.canEditCart = false;
			let params = {
				"product_id": product.product.id,
				"product_qty": product.quantity + 1
			}
			this.updateProduct(params)
		}
	}

	decrement(product: any): void {
		if (product.quantity > 1) {
			this.canEditCart = false;
			let params = {
				"product_id": product.product.id,
				"product_qty": product.quantity - 1
			}
			this.updateProduct(params)
		}
	}

	updateProduct(params: any){
		this.cartService.addLineCart(params)
			.subscribe({
				next: (res) => {
					if (res?.status == true) {
						this.cartData = res?.data?.cart;
						this.openSnackBar("Se edito el producto correctamente", true);
						this.getAllElements()
					}
				}
			})
	}


	/**
	 * Close the panel
	 */
	close(): void {
		// Return if the panel has already closed
		if (!this.opened) {
			return;
		}
		this.addCodeBool = false;

		// Close the panel
		this._toggleOpened(false);
	}

	/**
	 * Toggle the panel
	 */
	toggle(): void {
		if (this.opened) {
			this.close();
		}
		else {
			this.open();
		}
	}

	/**
	 * Select the chat
	 *
	 * @param id
	 */
	// selectChat(id: string): void {
	//   // Open the panel
	//   this._toggleOpened(true);

	//   // Get the chat data
	//   // this._quickChatService.getChatById(id).subscribe();
	// }

	/**
	 * Track by function for ngFor loops
	 *
	 * @param index
	 * @param item
	 */
	// trackByFn(index: number, item: any): any {
	//   return item.id || index;
	// }

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Show the backdrop
	 *
	 * @private
	 */
	private _showOverlay(): void {
		this._hideOverlay();
		this._overlay = this._renderer2.createElement('div');
		this._overlay.classList.add('app-sidebar-overlay');
		// Append al body para que siempre cubra toda la pantalla:
		this._renderer2.appendChild(this._document.body, this._overlay);
		this._scrollStrategy.enable();
		this._overlay.addEventListener('click', () => this.close());
	}


	/**
	 * Hide the backdrop
	 *
	 * @private
	 */
	private _hideOverlay(): void {
		if (!this._overlay) {
			return;
		}

		// If the backdrop still exists...
		if (this._overlay) {
			// Remove the backdrop
			this._overlay?.parentNode?.removeChild(this._overlay);
			this._overlay = null;
		}

		// Disable block scroll strategy
		this._scrollStrategy.disable();
	}

	/**
	 * Open/close the panel
	 *
	 * @param open
	 * @private
	 */
	private _toggleOpened(open: boolean): void {
		// Set the opened
		this.opened = open;

		// If the panel opens, show the overlay
		if (open) {
			this._showOverlay();
		}
		// Otherwise, hide the overlay
		else {
			this._hideOverlay();
		}
	}

	goToCheckout(): void {
		const payload = this.dataSource
			.filter(p => p.quantity > 0)
			.map(p => ({
				product_id: p.id,
				quantity: p.quantity
			}));
		this._router.navigate([`/check-out/${this.uuid}`]);
		this.close();
	}

	goProducts(){
		this.router.navigate(['/products']);
		this.close();
	}

	//Mensaje
	openSnackBar(message: string, isSuccess: boolean): void {
		this._snackBar.open(message, '', {
		  horizontalPosition: 'right',
		  verticalPosition: 'top',
		  duration: 1000,
		  panelClass: [isSuccess ? 'success-snackbar' : 'error-snackbar', 'center-text-snackbar'],
		});
	  }
}
